<template>
  <div class="summary">
    <div class="panels form-section">
      <div class="panel-left-flex panel-left-gap">
        <h4>Requirements</h4>
        <div class="form-section">
          <label>Do you have a car size preference?</label>
          <textarea v-model="car" placeholder="Optional" />
        </div>
        <div class="form-section">
          <label>Do you have a preferred rental company?</label>
          <textarea v-model="company" placeholder="Optional" />
        </div>
        <div class="form-section">
          <label>Any other car requirements?</label>
          <textarea v-model="other" placeholder="Optional" />
        </div>
      </div>
      <div class="panel-right-flex panel-right-gap">
        <h4>Summary</h4>
        <div v-for="(leg, index) in cars.route" :key="index" class="item">
          <div class="line">{{ leg.placeCollect.name }}</div>
          <div class="line"><span>Pick-up</span>{{ getDateFlightfox(leg.dateCollect) }}</div>
          <div class="line"><span>Drop-off</span>{{ getDateFlightfox(leg.dateReturn) }}</div>
          <div v-if="cars.isReturnDifferentPlace" class="line">
            {{ leg.placeReturn.name }}
          </div>
        </div>
      </div>
    </div>
    <div id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

import DateTime from "../utils/datetime.js";

const emit = defineEmits(["complete", "scroll", "update:isSavedRoute", "update:carsOther"]);
defineProps(["cars"]);

const { getDateFlightfox } = DateTime();

const car = ref(null);
const company = ref(null);
const other = ref(null);
const otherFormatted = computed(() => {
  var desc = "Car Type: " + (car.value ? car.value : "NA") + "\n";
  desc += "Company: " + (company.value ? company.value : "NA") + "\n";
  desc += "Other: " + (other.value ? other.value : "NA");
  return desc;
});

const back = () => {
  emit("update:isSavedRoute", false);
};

const next = () => {
  emit("update:carsOther", otherFormatted.value);
  emit("complete");
  emit("scroll");
};
</script>
